module.exports = __webpack_public_path__ + "4a8f6428895834c4fb613b641e9aba53.png";